
/**
 * Detects the language from the URL path.
 * Supports both "/:country/page" and "/page/:country/:language/" URL patterns.
 * Defaults to 'de' if no supported language is found.
 * @returns {string} The two-letter language code.
 */
export const getLanguageFromPath = (): string => {
  // Add all the language codes your app supports
  const supportedLangs: string[] = ['fr', 'de', 'en']; // Add more as needed
  const defaultLang = 'de';

  // Get path parts, removing empty strings from leading/trailing slashes
  const pathParts = window.location.pathname.split('/').filter(part => part);

  let detectedLang = defaultLang;
  for (const part of pathParts) {
    if (supportedLangs.includes(part.toLowerCase())) {
      detectedLang = part.toLowerCase();
    }

    if (part.toLowerCase() === 'gb') {
      detectedLang = 'en';
    }
  }

  return detectedLang;
};